const RWDXReviews = (): void => {
    const readMoreButtons = document.querySelectorAll<HTMLButtonElement>(".review-read-more");

    const handleReviewButtonClick = (e: MouseEvent): void => {
        const clickedReviewBtn = e.target as HTMLButtonElement;
        const parentReview = clickedReviewBtn.closest('.review__body') as HTMLElement | null;
        const carouselElement = clickedReviewBtn.closest('div[data-rwdx-carousel-auto]') as HTMLElement | null;

        if (parentReview) {
            const currentReviewState = parentReview.getAttribute('data-review-text-open');
            const newReviewState = currentReviewState === 'true' ? 'false' : 'true';
            parentReview.setAttribute('data-review-text-open', newReviewState);

            clickedReviewBtn.innerHTML = newReviewState === 'true' ? "Read less" : "Read more";

            carouselElement.setAttribute("data-rwdx-carousel-auto", newReviewState === 'true' ? "false" : "true")
        }
    };

    readMoreButtons.forEach((button: HTMLButtonElement) => {
        button.addEventListener('click', handleReviewButtonClick);
    });
};

export const closeReviews = () => {
    const readMoreButtons = document.querySelectorAll<HTMLButtonElement>(".review-read-more");

    const handleReviewButtonClick = (button: HTMLButtonElement): void => {
        const parentReview = button.closest('.review__body') as HTMLElement | null;
        const carouselElement = button.closest('div[data-rwdx-carousel-auto]') as HTMLElement | null;

        if (parentReview) {

            parentReview.setAttribute('data-review-text-open', "false");
            button.innerHTML = "Read more";
            carouselElement.setAttribute("data-rwdx-carousel-auto", "false")
        }
    };

    readMoreButtons.forEach((button: HTMLButtonElement) => {
        handleReviewButtonClick(button)
    });
}

export default RWDXReviews